import localStorage from '@/utils/localStorage';

import * as service from './service';

const services = { ...service };

const state = {
  uid: 0,
  userInfo: {},
};

const mutations = {
  setUID(state, number) {
    state.uid = number;
  },
  setUserInfo(state, obj) {
    state.userInfo = obj;
  },
};

const actions = {
  // 事件
  async checkAuth({ dispatch }, to) {
    try {
      await dispatch('authBefore', to);
      await dispatch('getUserInfo');
    } finally {
      await dispatch('authAfter', to);
    }
  },
  async authSuccess({ dispatch }) {
    await dispatch('getUserInfo');
  },
  setValue({ commit }, { key, mutation, value }) {
    const thisValue = value ?? localStorage.get(key);
    if (thisValue) {
      const root = mutation.indexOf('/') > -1;
      commit(mutation, thisValue, { root });
      localStorage.set(key, thisValue);
    }
  },
  // 步骤
  authBefore() {
    // 什么也不做...
  },
  getUserInfo({ commit }) {
    return services.getUserInfo().then((res) => {
      commit('setUID', res.data.uid);
      commit('setUserInfo', res.data);
    });
  },
  authAfter() {
    // 什么也不做...
  },
};

export default {
  namespaced: true,
  services,
  state,
  mutations,
  actions,
};
